import '../styles/pages/Home.scss'
import heroImage from '../assets/hero.png'
import heroMobile from '../assets/heromb.png'
import ballsImage from '../assets/balls.svg'
import spiderImage from '../assets/bgspider.svg'
import {useNavigate} from 'react-router-dom'
import { useEffect, useState } from 'react';
import Card from '../components/Card';
import ProductCard from '../components/ProductCard'
import SERVER from '../hooks/useServer';
import livraisonIcon from '../assets/icons/timing.svg'
import checkIcon from '../assets/icons/contract.svg'
import paiementIcon from '../assets/icons/payment.svg'
import securityIcon from '../assets/icons/quality.svg'
import stars from '../assets/icons/stars.png'
import { IoChevronBack, IoChevronForwardOutline } from "react-icons/io5";
import { useCart } from '../hooks/cart';
import { FaArrowRightLong } from "react-icons/fa6";
import { PiShoppingCartSimple } from "react-icons/pi";
import { useTranslation } from 'react-i18next';
import { useApi } from '../hooks/useApi';
import { formatPrice } from '../hooks/generalHooks';

const Home = () => {
    const { t, i18n } = useTranslation();
    const { addToCart } = useCart();
    const navigate = useNavigate();
    const { fetchCategories, fetchFeaturedProducts, fetchTopPromotions } = useApi();
    const [categories, setCategories] = useState([]);
    const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
    const [highlights, setHighlights] = useState([]);
    const [topPromotions, setTopPromotions] = useState([])
    const avis = t('home.reviews', { returnObjects: true });
    // const avis = [
    //     {
    //         avis: 'Excellentes balances, trés precises et faciles a utiliser Livraison rapide et service client au top',
    //         name: 'Jean Dupont'
    //     },
    //     {
    //         avis: 'Produit de qualité supérieure, très satisfait de mon achat. Je recommande!',
    //         name: 'Marie Lambert'
    //     },
    //     {
    //         avis: 'Service client exceptionnel et produits conformes à la description. Livraison dans les délais.',
    //         name: 'Thomas Martin'
    //     }
    // ];

    const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
    const [currentPromotionIndex, setCurrentPromotionIndex] = useState(0);
    const categoriesPerPage = 4;
    const categoriesPerPageMobile = 2; // Only 2 categories on mobile
    const promotionsPerPage = 4;
    const promotionsPerPageMobile = 2; // Only 2 promotions on mobile

    const nextReview = () => {
        setCurrentReviewIndex((prevIndex) => 
            prevIndex === avis.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevReview = () => {
        setCurrentReviewIndex((prevIndex) => 
            prevIndex === 0 ? avis.length - 1 : prevIndex - 1
        );
    };

    const goToCategoryPage = (index) => {
        setCurrentCategoryIndex(index);
    };

    const goToPromotionPage = (index) => {
        setCurrentPromotionIndex(index);
    };

    const getVisibleCategories = () => {
        const isMobile = window.innerWidth < 1024; // lg breakpoint
        const perPage = isMobile ? categoriesPerPageMobile : categoriesPerPage;
        const startIndex = currentCategoryIndex * perPage;
        return categories.slice(startIndex, startIndex + perPage);
    };

    const getVisiblePromotions = () => {
        const isMobile = window.innerWidth < 1024; // lg breakpoint
        const perPage = isMobile ? promotionsPerPageMobile : promotionsPerPage;
        const startIndex = currentPromotionIndex * perPage;
        return topPromotions.slice(startIndex, startIndex + perPage);
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                // Fetch categories
                const categoriesData = await fetchCategories();
                setCategories(categoriesData);
                
                // Fetch highlights
                const highlightsData = await fetchFeaturedProducts();
                const highlights = [];
                
                if (highlightsData.bestSeller && Object.keys(highlightsData.bestSeller).length !== 0) {
                    highlights.push({ titleKey: "home.topSales", product: highlightsData.bestSeller });
                }
                
                if (highlightsData.newest && Object.keys(highlightsData.newest).length !== 0) {
                    highlights.push({ titleKey: "home.newProduct", product: highlightsData.newest });
                }
                
                if (highlightsData.promotion && Object.keys(highlightsData.promotion).length !== 0) {
                    highlights.push({ titleKey: "home.specialOffers", product: highlightsData.promotion });
                }
                
                setHighlights(highlights);
                
                // Fetch promotions
                const promotionsData = await fetchTopPromotions();
                setTopPromotions(promotionsData.products || []);
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        loadData();
    }, [i18n.language, fetchCategories, fetchFeaturedProducts, fetchTopPromotions]);

    return (
        <div className=''>
            {/* Hero Section with Tailwind */}
            <div 
                className="relative w-full h-[700px] md:h-[550px] bg-[#f3f4f3] overflow-hidden mb-6"
            >
                {/* Hero Image - Only visible on mobile as img tag */}
                <img 
                    src={heroMobile}
                    alt="Hero"
                    className="absolute top-[110px] left-9 w-[50%] h-auto object-contain object-left-top lg:hidden z-0"
                />
                
                {/* Hero Image - Background image on desktop */}
                <div 
                    className="hidden lg:block absolute inset-0 bg-contain bg-no-repeat bg-[position:right_0%_bottom] z-0"
                    style={{ 
                        backgroundImage: `url(${heroImage})`
                    }}
                />

                {/* Blue balls decoration - Top Right */}
                <div className="absolute top-0 max-md:-left-10 md:right-[60px] w-[85%]  md:w-1/3 h-1/2 z-10">
                    <img 
                        src={ballsImage} 
                        alt="decoration" 
                        className="w-full h-full object-contain"
                    />
                </div>

                {/* Spider web decoration - Bottom Right */}
                <div className="absolute top-[120px] -right-[80px] md:bottom-0 md:-right-[600px] w-full h-[40%] md:h-[75%] z-10">
                    <img
                        src={spiderImage} 
                        alt="decoration" 
                        className="w-full h-full object-contain"
                    />
                </div>

                {/* Content Container */}
                <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-end lg:items-center pb-8 lg:pb-0">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center w-full">
                        {/* Left Content */}
                        <div className="space-y-3 md:space-y-6 text-center lg:text-left">
                            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight font-montserrat">
                                {t('home.bannerTitle')}
                            </h1>
                            <p className="text-base sm:text-xl max-w-sm mx-auto lg:mx-0 text-black leading-relaxed font-montserrat font-light">
                                {t('home.bannerSubtitle')}
                            </p>
                            <div className="flex justify-center lg:justify-start">
                                <button 
                                    onClick={() => navigate('/products')}
                                    className="inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-full transition-colors duration-200 shadow-lg hover:shadow-xl"
                                >
                                    {t('home.viewRange')} 
                                    <FaArrowRightLong />
                                </button>
                            </div>
                        </div>

                        {/* Right Content - Can be empty or add additional content */}
                        <div className="relative hidden lg:flex justify-center lg:justify-end">
                            {/* Optional: Add any additional content here */}
                        </div>
                    </div>
                </div>
            </div>

            <main>
                {/* Categories Section with Tailwind */}
                <div className="w-full max-w-7xl mx-auto px-4">
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8 font-montserrat">
                        {t('home.featuredCategories')}
                    </h3>
                    
                    <div className="relative">
                        {/* Categories Grid */}
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                            {getVisibleCategories().length > 0 ? (
                                getVisibleCategories().map((category) => (
                                    <Card 
                                        key={category.id} 
                                        title={category.title} 
                                        image={`${SERVER}/${category.banner_image}`} 
                                        onClick={() => {
                                            navigate(`/products/${category.title}`, { state: { categoryId: category.id } });
                                        }} 
                                    />
                                ))
                            ) : (
                                <div className="col-span-full text-center text-gray-500">
                                    {t('home.noCategories')}
                                </div>
                            )}
                        </div>
                        
                        {/* Pagination Dots */}
                        {categories.length > categoriesPerPageMobile && (
                            <div className="flex justify-center items-center gap-2 mt-8">
                                {Array.from({ 
                                    length: Math.ceil(categories.length / (window.innerWidth < 1024 ? categoriesPerPageMobile : categoriesPerPage)) 
                                }).map((_, index) => (
                                    <button
                                        key={index}
                                        className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                                            currentCategoryIndex === index 
                                                ? 'bg-primary ' 
                                                : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                        onClick={() => goToCategoryPage(index)}
                                        aria-label={`Go to page ${index + 1}`}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Top Sales Section */}
                {highlights.length > 0 && (
                    <div className="w-full max-w-7xl mx-auto px-4 mt-16">
                        {/* Desktop Grid */}
                        <div className="hidden lg:grid lg:grid-cols-4 gap-6">
                            {highlights.map((highlight, index) => (
                                <div key={index}>
                                    {index === 0 ? (
                                        /* Featured Card - First Item */
                                        <div 
                                            className="bg-primary rounded-[36px] py-4 px-8 flex flex-col items-center justify-between h-full cursor-pointer hover:shadow-xl transition-shadow"
                                            onClick={() => {
                                                navigate(`/product/${highlight.product.category_title}/${highlight.product.sub_category_title}/${highlight.product.title}`, { 
                                                    state: { categoryId: highlight.product.category_id, subCategoryId: highlight.product.sub_category_id, productId: highlight.product.id } 
                                                });
                                            }}
                                        >
                                            <div className="text-white mb-3">
                                                <h3 className="text-3xl font-meduim leading-tight">
                                                    {t(highlight.titleKey)}
                                                </h3>
                                            </div>
                                            
                                            <div className="relative w-full aspect-square">
                                                <img 
                                                    src={`${SERVER}/${highlight.product.banner_image}`}
                                                    alt={highlight.product.title}
                                                    className="w-[80%] h-full object-contain"
                                                />
                                                {highlight.product.promotion > 0 && (
                                                    <span className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        -{formatPrice(highlight.product.promotion, 0)}%
                                                    </span>
                                                )}
                                                {highlight.product.nouveaute && !highlight.product.promotion && (
                                                    <span className="absolute top-1 right-1 bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        NEW
                                                    </span>
                                                )}
                                            </div>
                                            <div className='w-full flex justify-end'>
                                                <button 
                                                className="w-10 h-10 bg-transparent border text-white hover:text-primary border-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <FaArrowRightLong className="" size={18} />
                                            </button>
                                            </div>
                                            
                                        </div>
                                    ) : (
                                        /* Regular Product Cards */
                                        <div 
                                            className="bg-white rounded-[36px] p-4 flex flex-col items-center cursor-pointer hover:shadow-xl transition-shadow border border-gray-200 h-full"
                                            onClick={() => {
                                                navigate(`/product/${highlight.product.category_title}/${highlight.product.sub_category_title}/${highlight.product.title}`, { 
                                                    state: { categoryId: highlight.product.category_id, subCategoryId: highlight.product.sub_category_id, productId: highlight.product.id } 
                                                });
                                            }}
                                        >
                                            <div className="relative w-full h-full mb-3 mx-auto">
                                                <img 
                                                    src={`${SERVER}/${highlight.product.banner_image}`}
                                                    alt={highlight.product.title}
                                                    className="w-full h-full object-contain bg-gray-100 rounded-[36px]"
                                                />
                                                {highlight.product.promotion > 0 && (
                                                    <span className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        -{formatPrice(highlight.product.promotion, 0)}%
                                                    </span>
                                                )}
                                                {highlight.product.nouveaute && !highlight.product.promotion && (
                                                    <span className="absolute top-1 right-1 bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        NEW
                                                    </span>
                                                )}
                                            </div>
                                            
                                            <h4 className="text-gray-900 font-medium text-sm text-start mb-3 line-clamp-2 min-h-[2.5rem]">
                                                {highlight.product.title}
                                            </h4>
                                            
                                            <div className="flex items-center justify-between w-full mt-auto">
                                                {highlight.product.promotion > 0 ? (
                                                    <div className="flex flex-col">
                                                        <span className="text-primary font-bold text-lg">
                                                            € {formatPrice(highlight.product.price * (1 - highlight.product.promotion / 100))}
                                                        </span>
                                                        <span className="text-gray-400 line-through text-xs">
                                                            € {formatPrice(highlight.product.price)}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <span className="text-primary font-bold text-lg">
                                                        € {formatPrice(highlight.product.price)}
                                                    </span>
                                                )}
                                                
                                                <button 
                                                    className="w-10 h-10 bg-primary rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        addToCart(highlight.product);
                                                    }}
                                                >
                                                    <PiShoppingCartSimple className="text-white" size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Mobile Layout */}
                        <div className="lg:hidden">
                            <div className="flex gap-4">
                                {/* Featured Card - Fixed on Left */}
                                {highlights.length > 0 && (
                                    <div className="flex-shrink-0 w-[45%]">
                                        <div 
                                            className="bg-primary rounded-[36px] py-6 px-4 flex flex-col items-center justify-between h-[300px] cursor-pointer hover:shadow-xl transition-shadow"
                                            onClick={() => {
                                                navigate(`/product/${highlights[0].product.category_title}/${highlights[0].product.sub_category_title}/${highlights[0].product.title}`, { 
                                                    state: { categoryId: highlights[0].product.category_id, subCategoryId: highlights[0].product.sub_category_id, productId: highlights[0].product.id } 
                                                });
                                            }}
                                        >
                                            <div className="text-white mb-3">
                                                <h3 className="text-xl font-medium leading-tight text-center">
                                                    {t(highlights[0].titleKey)}
                                                </h3>
                                            </div>
                                            
                                            <div className="relative w-full aspect-square mb-3">
                                                <img 
                                                    src={`${SERVER}/${highlights[0].product.banner_image}`}
                                                    alt={highlights[0].product.title}
                                                    className="w-[80%] mx-auto h-full object-contain"
                                                />
                                                {highlights[0].product.promotion > 0 && (
                                                    <span className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        -{formatPrice(highlights[0].product.promotion, 0)}%
                                                    </span>
                                                )}
                                                {highlights[0].product.nouveaute && !highlights[0].product.promotion && (
                                                    <span className="absolute top-1 right-1 bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                        NEW
                                                    </span>
                                                )}
                                            </div>
                                            <div className='w-full flex justify-end'>
                                                <button 
                                                    className="w-10 h-10 bg-transparent border-2 text-white hover:text-primary border-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <FaArrowRightLong size={18} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Regular Products - Scrollable on Right */}
                                <div className="flex-1 flex flex-col">
                                    <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-4">
                                        {highlights.slice(1).map((highlight, index) => (
                                            <div key={index} className="flex-shrink-0 w-[85%] snap-center">
                                                <div 
                                                    className="bg-white rounded-[36px] p-2 flex flex-col items-center cursor-pointer hover:shadow-xl transition-shadow border border-gray-200 h-[300px]"
                                                    onClick={() => {
                                                        navigate(`/product/${highlight.product.category_title}/${highlight.product.sub_category_title}/${highlight.product.title}`, { 
                                                            state: { categoryId: highlight.product.category_id, subCategoryId: highlight.product.sub_category_id, productId: highlight.product.id } 
                                                        });
                                                    }}
                                                >
                                                    <div className="relative w-full aspect-square mb-4 bg-gray-100 rounded-[36px]">
                                                        <img 
                                                            src={`${SERVER}/${highlight.product.banner_image}`}
                                                            alt={highlight.product.title}
                                                            className="w-full h-full object-contain p-2"
                                                        />
                                                        {highlight.product.promotion > 0 && (
                                                            <span className="absolute top-3 right-3 bg-red-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                                -{formatPrice(highlight.product.promotion, 0)}%
                                                            </span>
                                                        )}
                                                        {highlight.product.nouveaute && !highlight.product.promotion && (
                                                            <span className="absolute top-3 right-3 bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                                NEW
                                                            </span>
                                                        )}
                                                    </div>
                                                    
                                                    <h4 className="text-gray-900 font-medium text-base text-center mb-4 line-clamp-2 min-h-[3rem]">
                                                        {highlight.product.title}
                                                    </h4>
                                                    
                                                    <div className="flex items-center justify-between w-full mt-auto">
                                                        {highlight.product.promotion > 0 ? (
                                                            <div className="flex flex-col">
                                                                <span className="text-primary font-bold text-base">
                                                                    € {formatPrice(highlight.product.price * (1 - highlight.product.promotion / 100))}
                                                                </span>
                                                                <span className="text-gray-400 line-through text-base">
                                                                    € {formatPrice(highlight.product.price)}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-primary font-bold text-base">
                                                                € {formatPrice(highlight.product.price)}
                                                            </span>
                                                        )}
                                                        
                                                        <button 
                                                            className="w-8 h-8 bg-primary rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                addToCart(highlight.product);
                                                            }}
                                                        >
                                                            <PiShoppingCartSimple className="text-white" size={20} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Pagination Dots - Centered on screen for regular products only */}
                            {highlights.length > 1 && (
                                <div className="flex justify-center items-center gap-2 mt-4 w-full">
                                    {highlights.slice(1).map((_, index) => (
                                        <button
                                            key={index}
                                            className="w-2.5 h-2.5 rounded-full bg-gray-300 transition-all duration-300"
                                            aria-label={`Go to slide ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Promotions Section */}
                {topPromotions.length > 0 && (
                    <div className="w-full max-w-7xl mx-auto px-4 mt-16">
                        <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8 font-montserrat">
                            {t('home.ourPromotions')}
                        </h3>
                        
                        <div className="relative">
                            {/* Promotions Grid */}
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                                {getVisiblePromotions().length > 0 ? (
                                    getVisiblePromotions().map((promotion, index) => (
                                        <div 
                                            key={index}
                                            className="bg-white rounded-[36px] p-4 md:p-6 flex flex-col items-center cursor-pointer hover:shadow-xl transition-shadow border border-gray-200"
                                            onClick={() => {
                                                navigate(`/product/${promotion.category_title}/${promotion.sub_category_title}/${promotion.title}`, { 
                                                    state: { categoryId: promotion.category_id, subCategoryId: promotion.sub_category_id, productId: promotion.id } 
                                                });
                                            }}
                                        >
                                            {/* Image Container */}
                                            <div className="relative w-full aspect-square mb-3 md:mb-4 bg-gray-50 rounded-[36px] flex items-center justify-center">
                                                <img 
                                                    src={`${SERVER}/${promotion.banner_image}`}
                                                    alt={promotion.title}
                                                    className="w-4/5 h-4/5 object-contain"
                                                />
                                                {promotion.promotion > 0 && (
                                                    <span className="absolute top-2 left-2 md:top-3 md:left-3 bg-red-600 text-white px-2 py-1 md:px-3 md:py-2 rounded-full text-xs md:text-sm font-bold">
                                                        {formatPrice(promotion.promotion, 0)}%
                                                    </span>
                                                )}
                                                {promotion.nouveaute && !promotion.promotion && (
                                                    <span className="absolute top-2 left-2 md:top-3 md:left-3 bg-green-600 text-white px-2 py-1 md:px-3 md:py-2 rounded-full text-xs md:text-sm font-bold">
                                                        NEW
                                                    </span>
                                                )}
                                            </div>
                                            
                                            {/* Product Title */}
                                            <h4 className="text-gray-900 font-medium text-sm md:text-base text-center mb-3 md:mb-4 line-clamp-2 min-h-[2.5rem] md:min-h-[3rem] w-full">
                                                {promotion.title}
                                            </h4>
                                            
                                            {/* Price Section */}
                                            <div className="flex items-center justify-center gap-2 md:gap-3 w-full">
                                                {promotion.promotion > 0 ? (
                                                    <>
                                                        <span className="text-red-600 font-bold text-lg md:text-2xl">
                                                            € {formatPrice(promotion.price * (1 - promotion.promotion / 100))}
                                                        </span>
                                                        <span className="text-gray-400 line-through text-sm md:text-base">
                                                            € {formatPrice(promotion.price)}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span className="text-red-600 font-bold text-lg md:text-2xl">
                                                        € {formatPrice(promotion.price)}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-span-full text-center text-gray-500">
                                        {t('home.noPromotions')}
                                    </div>
                                )}
                            </div>
                            
                            {/* Pagination Dots */}
                            {topPromotions.length > promotionsPerPageMobile && (
                                <div className="flex justify-center items-center gap-2 mt-8">
                                    {Array.from({ 
                                        length: Math.ceil(topPromotions.length / (window.innerWidth < 1024 ? promotionsPerPageMobile : promotionsPerPage)) 
                                    }).map((_, index) => (
                                        <button
                                            key={index}
                                            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                                                currentPromotionIndex === index 
                                                    ? 'bg-primary' 
                                                    : 'bg-gray-300 hover:bg-gray-400'
                                            }`}
                                            onClick={() => goToPromotionPage(index)}
                                            aria-label={`Go to promotion page ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                {/* Why Choose Us Section */}
                <div className="w-full max-w-6xl mx-auto px-4 mt-20 mb-16">
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12 font-montserrat">
                        {t('home.whyChooseUs')}
                    </h3>
                    
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {/* Certified */}
                        <div className="bg-white rounded-2xl p-8 flex flex-col items-center justify-center text-center shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <img src={checkIcon} alt='certified-icon' className="w-full h-full object-contain" />
                            </div>
                            <span className="text-gray-700 font-medium text-base">
                                {t('home.certified')}
                            </span>
                        </div>

                        {/* Fast Delivery */}
                        <div className="bg-white rounded-2xl p-8 flex flex-col items-center justify-center text-center shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <img src={livraisonIcon} alt='delivery-icon' className="w-full h-full object-contain" />
                            </div>
                            <span className="text-gray-700 font-medium text-base">
                                {t('home.fastDelivery')}
                            </span>
                        </div>

                        {/* High Quality */}
                        <div className="bg-white rounded-2xl p-8 flex flex-col items-center justify-center text-center shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <img src={securityIcon} alt='quality-icon' className="w-full h-full object-contain" />
                            </div>
                            <span className="text-gray-700 font-medium text-base">
                                {t('home.highQuality')}
                            </span>
                        </div>

                        {/* Secure Payment */}
                        <div className="bg-white rounded-2xl p-8 flex flex-col items-center justify-center text-center shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <img src={paiementIcon} alt='payment-icon' className="w-full h-full object-contain" />
                            </div>
                            <span className="text-gray-700 font-medium text-base">
                                {t('home.securePayment')}
                            </span>
                        </div>
                    </div>
                </div>
                
                {/* Customer Reviews Section */}
                <div className="w-full max-w-6xl mx-auto px-4 mt-20 mb-16">
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12 font-montserrat">
                        {t('home.customerReviews')}
                    </h3>
                    
                    {/* Desktop - Show 3 cards */}
                    <div className="hidden md:grid md:grid-cols-3 gap-12 mb-8">
                        {avis.map((review, index) => (
                            <div 
                                key={index}
                                className={`rounded-3xl p-8 flex flex-col items-start text-start transition-all duration-300 ${
                                    index === currentReviewIndex 
                                        ? 'bg-primary text-white shadow-xl scale-105' 
                                        : 'bg-white text-gray-700 shadow-md'
                                }`}
                            >
                                <div className='flex items-center gap-3 mb-4'>
                                    {/* Avatar Placeholder */}
                                    <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden">
                                        <span className="text-2xl font-bold text-gray-600">
                                            {review.name.charAt(0)}
                                        </span>
                                    </div>
                                    
                                    {/* Stars and Name */}
                                    <div className='flex flex-col items-start'>
                                        <div className="flex gap-1 mb-1">
                                            {[...Array(5)].map((_, i) => (
                                                <svg key={i} className={`w-5 h-5 ${index === currentReviewIndex ? 'text-white' : 'text-yellow-400'}`} fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                                </svg>
                                            ))}
                                        </div>
                                        <h4 className={`font-semibold text-lg ${index === currentReviewIndex ? 'text-white' : 'text-black'}`}>
                                            {review.name}
                                        </h4>
                                    </div>
                                </div>
                                
                                {/* Review Text */}
                                <p className={`text-base leading-relaxed font-light ${index === currentReviewIndex ? 'text-white opacity-90' : 'text-black'}`}>
                                    {review.avis}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Mobile - Show 1 card */}
                    <div className="md:hidden mb-8 px-6">
                        <div className="bg-white rounded-3xl p-8 flex flex-col items-start text-start shadow-lg min-h-[280px]">
                            <div className='flex items-center gap-3 mb-4'>
                                {/* Avatar Placeholder */}
                                <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden flex-shrink-0">
                                    <span className="text-2xl font-bold text-gray-600">
                                        {avis[currentReviewIndex].name.charAt(0)}
                                    </span>
                                </div>
                                
                                {/* Stars and Name */}
                                <div className='flex flex-col items-start'>
                                    <div className="flex gap-1 mb-1">
                                        {[...Array(5)].map((_, i) => (
                                            <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                            </svg>
                                        ))}
                                    </div>
                                    <h4 className="font-semibold text-lg text-black">
                                        {avis[currentReviewIndex].name}
                                    </h4>
                                </div>
                            </div>
                            
                            {/* Review Text */}
                            <p className="text-base leading-relaxed font-light text-black">
                                {avis[currentReviewIndex].avis}
                            </p>
                        </div>
                    </div>
                    
                    {/* Navigation Arrows */}
                    <div className="flex justify-center items-center gap-4">
                        <button 
                            onClick={prevReview}
                            className="w-12 h-12 rounded-full border border-black flex items-center justify-center hover:bg-gray-100 transition-all"
                            aria-label="Previous review"
                        >
                            <IoChevronBack size={20} className="text-black" />
                        </button>
                        <button 
                            onClick={nextReview}
                            className="w-12 h-12 rounded-full border border-black flex items-center justify-center hover:bg-gray-100 transition-all"
                            aria-label="Next review"
                        >
                            <IoChevronForwardOutline size={20} className="text-black" />
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Home;